import React from 'react';
import "../../Styles/Landing.css";
import DidYouKnow from "./DidYouKnow"
import YouCanTrust from "./YouCanTrust"
import TrustedUs from "./TrustedUs"
import HealthPortal from "./HealthPortal"
import Clients from "./Clients"
import DataScienceHealth from "./DataScienceHealth"
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpLong } from "@fortawesome/free-solid-svg-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import LazyLoad from 'react-lazyload';
import backgroundImage  from '../../Photos/BackgroundHealthPortal.png'
import Footer from '../../../Footer';
import Privacy from './Privacy';



function LandingSlider() {
  const Navigate = useNavigate();

  const re = new RegExp(/^.*\//);
  const root = re.exec(window.location.href)

  window.onscroll = function() {
    if(document.URL === root[0]) {
      let tmp = document.getElementById("ToTheTop")
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        tmp.className = tmp.className.replace(" ScrollBackToTopHidden", "");
      } else {
        if(!tmp.className.includes("ScrollBackToTopHidden")) tmp.className += " ScrollBackToTopHidden"
      }
    }
  }

 

  return (
   <div   style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh', 
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    zIndex: 0,
  }}>
<DataScienceHealth/>
<Clients/>
<HealthPortal/>
<Privacy/>
<TrustedUs/>
<Footer/>

    
      <div className='ScrollBackToTopOuter ScrollBackToTopHidden' id="ToTheTop">
        <div className='ScrollBackToTop' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
          <FontAwesomeIcon 
            icon={faUpLong} 
            className='ScrollBackToTopUpArrow'
          />
        </div>
      </div>
    </div>
  );
}

export default LandingSlider; 
